var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoreLeads({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    "data-bbox": "20 20 160 160",
    viewBox: "20 20 160 160",
    height: 200,
    width: 200,
    xmlns: "http://www.w3.org/2000/svg",
    "data-type": "shape",
    role: "presentation",
    "aria-hidden": "true",
    "aria-label": "",
    fill: "#fff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M20 100.212c0 42.116 32.593 76.614 73.862 79.788V74.603L58.095 110.37l-8.889-8.889 41.905-41.905L100 50.688l8.889 8.889 41.905 41.905-8.889 8.889-35.556-35.556v104.974C147.619 176.614 180 142.116 180 100c0-44.021-35.767-80-80-80s-80 35.979-80 80.212z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreLeads);
export default __webpack_public_path__ + "static/media/more_leads.f443bc5b5f3d9db0fde690e1017653ba.svg";
export { ForwardRef as ReactComponent };